import { render, staticRenderFns } from "./concussionReport.vue?vue&type=template&id=dfc8844c&"
import script from "./concussionReport.vue?vue&type=script&lang=js&"
export * from "./concussionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports